import { Form } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { Next, Previous } from "../../../../Constant";
import { useAppDispatch } from "../../../../Redux-Toolkit/Hooks";
import { StudentFormPropsType } from "../../../../Type/FormLayoutType";
import FinishedForm from "./FinishedForm";
import { StudentTab2 } from "./StudentTab2";
import { StudentTab3 } from "./StudentTab3";
import { StudentTab1 } from "./StudentTab1";
import { handleStudentBackButton, handleStudentNextButton } from "../../../../Redux-Toolkit/Reducers/FormLayout/StudentWizardSlice";

const StudentForm = ({ handleImageLabelClick, imageUrl, getUserData, studentValidationForm, level, fileInputRef }: StudentFormPropsType) => {
  const dispatch = useAppDispatch();

  return (
    <Form onSubmit={(e) => e.preventDefault()} className="form-wizard">
      <div className={`tab ${level === 1 ? "d-block" : "d-none"}`}>
        <StudentTab1 studentValidationForm={studentValidationForm}  getUserData={getUserData}/>
      </div>
      <div className={`tab ${level === 2 ? "d-block" : "d-none"}`}>
        <StudentTab2 studentValidationForm={studentValidationForm} getUserData={getUserData} fileInputRef={fileInputRef} handleImageLabelClick={handleImageLabelClick} imageUrl={imageUrl} level={level} />
      </div>
      <div className={`tab ${level === 3 ? "d-block" : "d-none"}`}>
        <StudentTab3 studentValidationForm={studentValidationForm} getUserData={getUserData} />
      </div>
      {level === 4 && <FinishedForm />}
      <div>
        <div className="text-end pt-3">
          {level > 1 && (
            <Btn color="secondary" onClick={() => dispatch(handleStudentBackButton())}>
              {Previous}
            </Btn>
          )}
          <Btn color="primary" className={`ms-1 ${level === 4 ? "disabled" : ""}`} onClick={() => dispatch(handleStudentNextButton())}>
            {Next}
          </Btn>
        </div>
      </div>
    </Form>
  );
};

export default StudentForm;
